import {Component, Input} from "@angular/core";
import {SubmissionRuleResultsSummary} from "@components/main/spreading/state/manager";
import {SubmissionRuleActions} from "@services/template-data.service";

@Component({
    selector: 'app-das-submission-rule-results-summary',
    templateUrl: './das-submission-rule-results-summary.component.html',
    styleUrls: ['./das-submission-rule-results-summary.component.scss'],
    standalone: false
})
export class DasSubmissionRuleResultsSummaryComponent {
  @Input() ruleResultsSummary: SubmissionRuleResultsSummary;
  @Input() hasSubmissionRuleResults: boolean;

  protected readonly SubmissionRuleActions = SubmissionRuleActions;
}
